import {TextField} from '@ultradent/components';
import {Outlet} from 'react-router-dom';
import {Query} from 'react-apollo';
import {client} from '@core/GraphQLProvider';
import {Catalog} from '@services/ProductCatalogService/query.graphql';
import {Form, Formik} from 'formik';
import Icon from '@components/common/Icon';
import useProductDocumentationSearch from '@containers/Resources/ProductDocumentation/useProductDocumentationSearch';

const LBL_SEARCH = upi.i18n.getTextFromKey( 'lbl-searchForProduct', 'Search for a Product' );
const LBL_KEYWORD = upi.i18n.getTextFromKey( 'lbl-keywordItemNum', 'Keyword / Item#' );

const withQuery = ( Component ) => {
    function Wrapper ( props ) {
        return (
            <Query
                client={client}
                query={Catalog}
                variables={{
                    includeAllSkus: true
                }}>
                {( {data, error, loading} ) => {
                    // todo - handle error better
                    if ( error ) {
                        return <div>error</div>;
                    }

                    return <Root productList={data.allProducts}/>
                }}
            </Query>
        );
    }

    Wrapper.displayName = `withQuery(${Component.displayName || Component.name})`;

    return Wrapper;
};

export function Root ( {productList} ) {
    const productDocumentationApi = useProductDocumentationSearch( {data: productList} );

    return (
        <Formik
            onSubmit={productDocumentationApi.onQuery}
            enableReinitialize={true}
            initialValues={{
                productCategory: productDocumentationApi.currentQuery.productCategory,
                productLanguage: productDocumentationApi.currentQuery.productLanguage,
                keyword: productDocumentationApi.currentQuery.keyword
            }}
            render={( {values, handleChange} ) => (
                <Form>
                    <div class="md:flex w-full" data-testid="product-documentation-list">
                        <div className="md:w-1/4">
                            <div className="mb-6 px-6 pb-2 border border-grey-lighter border-solid">
                                <fieldset>
                                    <div className="input-group">
                                        <TextField
                                            id="keyword"
                                            inputClassName="py-6"
                                            label={LBL_SEARCH}
                                            value={values.keyword}
                                            onChange={handleChange}
                                            placeholder={LBL_KEYWORD}
                                            append={<Icon.ui name="search" wrapperClassName="block w-5 h-5"/>}
                                        />
                                    </div>
                                </fieldset>
                            </div>
                        </div>

                        <div className="md:w-3/4">
                            <div className="md:ml-8 flex-auto">
                                <Outlet context={{productDocumentationApi}}/>
                            </div>
                        </div>
                    </div>
                </Form>
            )}/>
    );
}

export default withQuery( Root );
